<template>
    <el-select :value="value" class="select" clearable filterable :placeholder="$t('shared.pleaseSelectCode')" :loading="loading" @change="change">
        <el-option  v-for="item in complaints" :key="item.id" :label="truncate(item.name, 150)" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import api from './api'
    export default {
        name: 'complaint-code-selector',
        props: {
            value: {},
            equipmentId: {
                type: Number,
                default: undefined
            },
            categoryName: {
                type: String,
                default: undefined
            },
            subCategoryName: {
                type: String,
                default: undefined
            },
        },
        data() {
            return {
                loading: false,
                complaints: [],
                filteredComplaints: []
            }
        },
        watch: {
            equipmentId: function (val) {
                if (!val) {
                    this.complaints = []
                } else {
                    this.loading = true
                    api.getComplaints(this.equipmentId).then(response => {
                        this.loading = false
                        this.complaints = response.data
                        this.filteredComplaints = response.data
                    })
                }
            },
            categoryName: function (val) {
                if (!val) {
                    this.complaints = this.filteredComplaints.slice();
                } else {
                    this.complaints = this.filteredComplaints.slice();
                    this.complaints = this.complaints.filter(e => e.category === val);
                }
            },
            subCategoryName: function (val) {
                if (!val) {
                    this.complaints = this.filteredComplaints.slice();
                    if (this.categoryName)
                        this.complaints = this.complaints.filter(e => e.category === this.categoryName);
                } else {
                    this.complaints = this.filteredComplaints.slice();
                    this.complaints = this.complaints.filter(e => e.subCategory === val);
                }
            }
        },
        methods: {
            change(val)
            {
                if (val) {
                    var code = val ? this.complaints.find(p => p.id === val) : undefined;
                    this.$emit('code-selected', code)
                    this.value = undefined;
                }
            },

            truncate(text, length) {
                if (text.length <= length) {
                    return text;
                } else {
                    return text.substring(0, length) + '...';
                }
            }
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/complaintcodeselector/ComplaintCodeSelector.vue